module.exports = __webpack_public_path__ + "static/osadolor-bfd7ae813d5cd65640140040dcbb63f7.png";